/**
 * Ritual types.
 */
enum RitualType {
  NewChatter = 'new_chatter',
}

export default RitualType
